import PropTypes from 'prop-types';
import React from 'react';

import {useSelector} from 'react-redux';
import {i18n} from 'src/i18n';
import selectors from 'src/modules/presupuesto/presupuestoSelectors';
import DrawerButton from 'src/view/shared/view/DrawerButton';
import PresupuestoView from '../view/PresupuestoView';

function PresupuestoListItem(props) {
  const hasPermissionToRead = useSelector(selectors.selectPermissionToRead);

  const valueAsArray = () => {
    const {value} = props;

    if (!value) {
      return [];
    }

    if (Array.isArray(value)) {
      return value;
    }

    return [value];
  };

  const displayableRecord = (record) => {
    return (
      <div key={record.id}>
        <DrawerButton
          drawerId={'DrawerPresupuestoViewPage'}
          type={'chip'}
          entity={'presupuesto'}
          tooltipTitle={i18n(record.descripcion)}
          buttonTitle={i18n(record.descripcion)}
          width={window.innerWidth * 0.55}
          record={record}
          component={<PresupuestoView record={record} drawer={true} />}
        />
      </div>
    );
  };

  if (!valueAsArray().length) {
    return null;
  }

  return <>{valueAsArray().map((value) => displayableRecord(value))}</>;
}

PresupuestoListItem.propTypes = {
  value: PropTypes.any,
};

export default PresupuestoListItem;
